module.exports = __webpack_public_path__ + "img/loading-day.726fdfd9.jpg";